import { render, staticRenderFns } from "./invadobay-property-card.vue?vue&type=template&id=19093ac8&scoped=true"
import script from "./invadobay-property-card.vue?vue&type=script&lang=js"
export * from "./invadobay-property-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19093ac8",
  null
  
)

export default component.exports